import React, { CSSProperties } from "react";
import initials from "initials";

import { divergingScheme1, divergingScheme2, divergingScheme3, divergingScheme4, getColor } from "../helpers/colors";
import { AvatarProps } from "../types/Avatar.types";

const colorsObj: Record<string, undefined> = {};
[
  ...divergingScheme1,
  ...divergingScheme2,
  ...divergingScheme3,
  ...divergingScheme4,
].forEach(value => {
  colorsObj[value] = void 0;
});
const colors = Object.keys(colorsObj);

function sumChars(str: string) {
  let sum = 0;
  for (let i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }
  return sum;
}

const Avatar: React.FC<AvatarProps> = (props) => {
  const classNames: string[] = [
    "c-avatar",
    "c-avatar--" + (props.size || "sm"),
  ];

  const backgroundColor = getColor(colors, sumChars(props.id || ""));

  const abbr = props.name ? initials(props.name) : "";
  const style: CSSProperties = {};

  if (!props.src && !props.srcSet) {
    style.backgroundColor = backgroundColor;
  }

  return (
    <span
      aria-label={props.name}
      className={classNames.join(" ")}
      style={style}
    >
      {props.src || props.srcSet ? (
        <img
          alt={`${props.name} photo`}
          src={props.src}
          srcSet={props.srcSet}
          style={{ minHeight: "100%", minWidth: "100%" }}
        />
      ) : (
        <span className="text-light text-uppercase">{abbr}</span>
      )}
    </span>
  );
};

export default Avatar;
